module.exports = __webpack_public_path__ + "img/anzera-logo-medium.48d5aa7f.png";